
"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import { AnimatePresence, motion } from "framer-motion";

// Ikonky sociálních sítí a mobilu
const icons = {
  instagram: '/icons/instagram (1).png',
  facebook: '/icons/facebook (1).png',
  whatsapp: '/icons/whatsapp.png',
  phone: '/icons/mobile2.png',
  tiktok: '/icons/tiktok.png',
};


const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);

      // Header se schová pouze pokud není otevřené menu
      if (open) {
        setIsVisible(true);
      } else if (scrollTop > lastScrollY && scrollTop > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, open]); // <- důležité!

  const menuItems = [
    { label: 'Služby', href: '/#sluzby' },
    { label: 'O mně', href: '/#o-nas' },
    { label: 'Galerie', href: '/galerie' },
    { label: 'Reference', href: '/#reference' },
    { label: 'Kontakt', href: '/#kontakt' },
  ];

  return (
    <>
      <header
          className="fixed w-full z-50 transition-all duration-500 top-4 px-4"
          style={{
            opacity: !open && isScrolled && !isVisible ? 0 : 1,
            transform: !open && isScrolled && !isVisible ? 'translateY(-150%)' : 'translateY(0)'
          }}
      >
        {/* Plovoucí kapsle s efektem rozmazaného skla */}
        <div className="max-w-6xl mx-auto px-6 flex justify-between items-center h-[72px] rounded-full shadow-lg backdrop-blur-md"
             style={{
               background: 'rgba(31, 46, 70, 0.85)', // Tmavě modrá s mírnou průhledností
               border: '1px solid rgba(253, 195, 15, 0.3)' // Jemný žlutý rámeček místo tvrdé linky
             }}>

          <a href="/" className="flex items-center gap-2 group logo-hover-animation" style={{ textDecoration: 'none' }}>
            <Image src="/galerie/Logo Elektroinstalace Trunec.png" alt="Logo Elektroinstalace Trunec" width={32} height={32} style={{ objectFit: 'contain', marginRight: 8 }} sizes="(max-width: 650px) 24px, 32px" priority />
            <span style={{ fontSize: '1.25rem', fontWeight: 700, fontFamily: 'var(--font-geist-sans, sans-serif)', color: '#FDC30F', letterSpacing: '0.04em', lineHeight: 1, display: 'block', textAlign: 'left' }}>
        Elektroinstalace<br />Trunec
      </span>
          </a>

          <nav className="hidden min-[960px]:flex gap-8">
            {menuItems.map((item) => (
                <a key={item.label} href={item.href} className="nav-underline transition-colors duration-300" style={{ color: '#ffffff', fontWeight: 600 }} onMouseEnter={(e) => e.currentTarget.style.color = '#FDC30F'} onMouseLeave={(e) => e.currentTarget.style.color = '#ffffff'}>
                  {item.label}
                </a>
            ))}
          </nav>

          {/* Kulaté tlačítko zasazené do plovoucí kapsle */}
          <a href="tel:+420704280499" className="ml-4 px-5 py-2.5 rounded-full font-bold shadow transition-all duration-300 hover:scale-105 hover:shadow-2xl group hidden min-[960px]:inline-flex items-center" style={{ background: '#FDC30F', color: '#1F2E46' }}>
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92V19a2 2 0 0 1-2.18 2A19.86 19.86 0 0 1 3 5.18 2 2 0 0 1 5 3h2.09a2 2 0 0 1 2 1.72c.13.81.37 1.6.7 2.34a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6.88 6.88l1.27-1.27a2 2 0 0 1 2.11-.45c.74.33 1.53.57 2.34.7A2 2 0 0 1 22 16.92z" /></svg>
            +420 704 280 499
          </a>

          <button className="min-[960px]:hidden z-50 flex flex-col justify-center items-center h-10 w-10 p-2 focus:outline-none" onClick={() => setOpen((prev) => !prev)} type="button">
            <span className={`block h-0.5 w-7 bg-white rounded transition-all duration-400 ease-in-out ${open ? 'rotate-45 translate-y-[3px]' : 'mb-1'}`} style={{ marginBottom: open ? 0 : 4 }}></span>
            <span className={`block h-0.5 w-7 bg-white rounded transition-all duration-400 ease-in-out ${open ? 'opacity-0' : 'mb-1'}`} style={{ marginBottom: open ? 0 : 4 }}></span>
            <span className={`block h-0.5 w-7 bg-white rounded transition-all duration-400 ease-in-out ${open ? '-rotate-45 -translate-y-[3px]' : ''}`}></span>
          </button>
        </div>
      </header>

      {/* Mobile menu */}
      {/* Fixní neviditelný obal, který drží přesné 16px okraje (px-4) a pozici shora */}
      {/* Fixní obal, který má natvrdo přišpendlené okraje 16px od krajů obrazovky */}
      <div className="fixed top-[100px] left-4 right-4 z-40 pointer-events-none">
        <AnimatePresence>
          {open && (
              <motion.nav
                  initial={{ y: -24, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -24, opacity: 0 }}
                  transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
                  /* w-full zajistí vyplnění obalu, mx-auto vycentruje na větších displejích */
                  className="w-full max-w-3xl mx-auto bg-[#1F2E46] px-6 pt-4 pb-4 flex flex-col space-y-2 shadow-xl rounded-[2.5rem] pointer-events-auto"
                  style={{
                    borderBottom: '2px solid #FDC30F',
                    boxShadow: '0 8px 32px 0 rgba(31,46,70,0.18)'
                  }}
              >
                {menuItems.map((item) => (
                    <a
                        key={item.label}
                        href={item.href}
                        className="block py-2 text-center text-base border-b border-white/10 last:border-0 hover:text-[#fdc30f] transition"
                        style={{ color: '#FDC30F', fontWeight: 600 }}
                        onClick={() => setOpen(false)}
                    >
                      {item.label}
                    </a>
                ))}
              </motion.nav>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

// Data pro kategorie projektů
const projectCategories = [
  {
    id: 1,
    title: "Podružný rozvaděče",
    description: "Práce zahrnovala montáž, osazení potřebných prvků a kabeláž.",
    icon: "🏠",
    images: [
      { src: "/galerie/maly_rozvadec1.webp", title: "Poddružný rozvaděč", description: "Práce zahrnovala montáž, osazení potřebných prvků a kabeláž. " },
      { src: "/galerie/maly_rozvadec2.webp", title: "Poddružný rozvaděč", description: "Práce zahrnovala montáž, osazení potřebných prvků a kabeláž. " }
    ]
  },
  {
    id: 2,
    title: "Kompletace domovního rozvaděče",
    description: "Tato zakázka zahrnovala kompletaci hlavního domovního rozvaděče pro novostavbu rodinného domu.",
    icon: "🏭",
    images: [
      { src: "/galerie/rozvadec2.webp", title: "Kompletace", description: "Tato zakázka zahrnovala kompletaci hlavního domovního rozvaděče pro novostavbu rodinného domu." },
      { src: "/galerie/rozvadec5.webp", title: "Přípravný rozvaděč", description: "Jako první jsem osadil moduly do předem připraveného rozvaděče." },
      { src: "/galerie/rozvadec4.webp", title: "Zapojení", description: "Dále jsem zapojil proudový chránič a přepěťovou ochranu." }
    ]
  },
  {
    id: 3,
    title: "Výměna LED diod",
    description: "V rámci této zakázky jsem provedl výměnu výkonného LED osvětlení na světelné rampě.",
    icon: "🏭",
    images: [
      { src: "/galerie/majaky1.webp", title: "LED rampa", description: "Po rozebrání LED rampy bylo potřeba pomocí osciloskopu zjistit typ použitých diod." },
      { src: "/galerie/majaky2.webp", title: "Přepájení ", description: "Poté následovalo jejich pečlivé přepájení na původní pozice. " }
    ]
  },
  {
    id: 4,
    title: "Zakázkový 3D tisk",
    description: "Zakázkový 3D tisk na míru od reklamních produktů až po technické díly.",
    icon: "🖨️",
    images: [
      { src: "/galerie/3dtisk1.webp", title: "3D tiskárna", description: "3D tiskárna" },
      { src: "/galerie/3dtisk2.webp", title: "Klínek do dveří nejen pro hasiče.", description: "Klínek do dveří nejen pro hasiče." },
      { src: "/galerie/3dtisk3.webp", title: "Tisk personalizovaných reklamních produktů.", description: "Tisk personalizovaných reklamních produktů." },
      { src: "/galerie/3dtisk4.webp", title: "Tisk držáků nářadí na DIN lištu", description: "Tisk držáků nářadí na DIN lištu" },
      { src: "/galerie/3dtisk5.webp", title: "Hadicová záslepka na hadice D,C,B", description: "Hadicová záslepka na hadice D,C,B" }
    ]
  },
  {
    id: 5,
    title: "Elektroměrový rozvaděč",
    description: "Elektroměrový rozvaděč",
    icon: "💡",
    images: [
      { src: "/galerie/elektromerovy_rozvadec1.webp", title: "Montáž", description: "Montáž podružného měření." },
      { src: "/galerie/elektromerovy_rozvadec2.webp", title: "Odstranění elektroinstalace", description: "Nejdřív jsem odstranil předchozí elektroinstalaci." },
      { src: "/galerie/elektromerovy_rozvadec3.webp", title: "Nový rozvaděč", description: "Pote jsem nainstaloval nový rozvaděč a zapojil podružné měření." }
    ]
  }
];
export default function Galerie() {
  const [selectedCategory, setSelectedCategory] = useState<number | null>(null);
  const [current, setCurrent] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalCurrent, setModalCurrent] = useState(0);

  const currentImages = selectedCategory
    ? projectCategories.find(cat => cat.id === selectedCategory)?.images || []
    : [];

  const prev = () => setCurrent((c) => (c === 0 ? currentImages.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === currentImages.length - 1 ? 0 : c + 1));

  const openModal = (index: number) => {
    setModalCurrent(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const modalPrev = () => setModalCurrent((c) => (c === 0 ? currentImages.length - 1 : c - 1));
  const modalNext = () => setModalCurrent((c) => (c === currentImages.length - 1 ? 0 : c + 1));

  const goBackToCategories = () => {
    setSelectedCategory(null);
    setCurrent(0);
  };

  // Zavření modalu při stisku ESC
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft' && currentImages.length > 0) modalPrev();
      if (e.key === 'ArrowRight' && currentImages.length > 0) modalNext();
    };

    if (isModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [isModalOpen, currentImages.length]);

  return (
    <div style={{
      fontFamily: 'sans-serif',
      color: '#1F2E46',
      background: '#fff',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Navbar />
      <main style={{ flex: 1, background: '#fff', padding: '0 0 0 0', fontFamily: 'sans-serif', display: 'block', minHeight: '100vh' }}>
        <div className="max-w-6xl mx-auto px-6">
          <h1
            style={{
              fontSize: '2.1rem',
              fontWeight: 800,
              marginBottom: '2.5rem',
              marginTop: '7.0rem',
              letterSpacing: '0.01em',
              color: '#FDC30F',
              textAlign: 'center',
              fontFamily: 'sans-serif',
            }}
          >
            Galerie realizovaných prací
          </h1>

          {!selectedCategory ? (
            // Zobrazení kategorií (jen název, náhled, počet fotek, tlačítko)
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {projectCategories.map((category) => (
                  <div
                    key={category.id}
                    onClick={() => setSelectedCategory(category.id)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setSelectedCategory(category.id);
                      }
                    }}
                    aria-label={`Zobrazit galerii: ${category.title}`}
                    className="group relative block overflow-hidden rounded-3xl ring-1 ring-slate-200 shadow-lg transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:ring-2 hover:ring-[#FDC30F] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FDC30F] cursor-pointer"
                    style={{ background: '#1F2E46' }}
                  >
                    <div className="relative aspect-[4/3] w-full overflow-hidden">
                      {/* Obrázek jako pozadí */}
                      <Image
                        src={category.images[0]?.src}
                        alt={category.images[0]?.title || 'Náhled projektu'}
                        fill
                        sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        className="object-cover transition-transform duration-700 ease-out group-hover:scale-[1.07]"
                        placeholder="blur"
                        blurDataURL="/galerie/placeholder.webp"
                      />
                      {/* Gradient pro čitelnost textu */}
                      <div className="absolute inset-0" style={{ background: 'linear-gradient(0deg, rgba(31,46,70,0.96) 0%, rgba(31,46,70,0.55) 45%, rgba(253,195,15,0.10) 100%)', zIndex: 2 }}></div>
                      {/* Text karty ukotvený u spodní hrany */}
                      <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0, zIndex: 3, padding: '1.25rem 1.35rem' }}>
                        <h4 className="text-xl font-extrabold" style={{ marginBottom: '0.5rem', letterSpacing: '0.01em', color: '#FDC30F', textShadow: '0 2px 8px rgba(31,46,70,0.55)' }}>{category.title}</h4>
                        <p className="text-sm sm:text-base leading-relaxed text-slate-100" style={{ margin: 0 }}>{category.images.length} fotek</p>
                        <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold" style={{ color: '#FDC30F' }}>
                          Zobrazit galerii
                          <svg className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M5 12h14M13 6l6 6-6 6" />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* Info text removed here, only one instance will remain below as requested */}
            </>
          ) : (
            // Zobrazení galerie vybrané kategorie
            <div className="flex flex-col items-center">
              <div className="w-full max-w-4xl mb-8">
                <button
                  onClick={goBackToCategories}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    background: '#1F2E46',
                    color: '#FDC30F',
                    border: 'none',
                    borderRadius: 8,
                    fontWeight: 700,
                    fontSize: '1.05rem',
                    padding: '0.6rem 1.4rem',
                    marginBottom: 24,
                    cursor: 'pointer',
                    boxShadow: '0 2px 8px #1F2E46',
                    transition: 'background 0.2s, color 0.2s',
                  }}
                  className="group hover:bg-yellow-500 hover:text-[#1F2E46]"
                >
                  <svg className="w-5 h-5 mr-2 group-hover:-translate-x-1 transition-transform" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M19 12H5M12 19l-7-7 7-7" />
                  </svg>
                  Zpět na kategorie
                </button>

                <h2 style={{ fontSize: '1.3rem', fontWeight: 700, color: '#1F2E46', marginBottom: 12, fontFamily: 'sans-serif' }}>
                  {projectCategories.find(cat => cat.id === selectedCategory)?.title}
                </h2>
                <p style={{ color: '#FDC30F', marginBottom: 32, fontFamily: 'sans-serif' }}>
                  {projectCategories.find(cat => cat.id === selectedCategory)?.description}
                </p>
              </div>

              {currentImages.length > 0 && (
                <>
                  <div className="relative w-full max-w-4xl aspect-[16/10] rounded-2xl shadow-lg overflow-hidden flex items-center justify-center group cursor-pointer" style={{ background: '#F8FAFC', border: '1px solid #FDC30F' }} onClick={() => openModal(current)}>
                    <button
                      onClick={(e) => { e.stopPropagation(); prev(); }}
                      aria-label="Předchozí"
                      className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-[#FDC30F] text-[#1F2E46] rounded-full p-2 sm:p-3 shadow transition-all z-10 border-none cursor-pointer"
                      style={{ boxShadow: '0 2px 8px #1F2E46', border: 'none' }}
                    >
                      <svg width="22" height="22" className="sm:w-7 sm:h-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>
                    </button>

                    <div style={{width: '100%', height: '100%', minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <Image
                        src={currentImages[current].src}
                        alt={currentImages[current].title}
                        width={800}
                        height={500}
                        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 80vw, 800px"
                        style={{objectFit: 'contain', maxHeight: 500, width: 'auto', margin: '0 auto', transition: 'all 0.3s'}}
                        className="transition-all duration-300"
                        placeholder="blur"
                        blurDataURL="/galerie/placeholder.webp"
                        loading="eager"
                        fetchPriority="high"
                      />
                    </div>

                    {/* Hover overlay s popisem - pouze malý box dole uprostřed */}
                    <div
                      className="absolute left-1/2 bottom-4 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300"
                      style={{
                        background: 'rgba(31,46,70,0.65)',
                        color: '#FDC30F',
                        padding: '0.8rem 1.1rem 0.6rem 1.1rem',
                        fontSize: '1rem',
                        boxShadow: '0 2px 12px 0 rgba(31,46,70,0.10)',
                        borderRadius: 12,
                        minWidth: 220,
                        maxWidth: 340,
                        width: '80vw',
                        textAlign: 'center',
                        zIndex: 20,
                      }}
                    >
                      <h3 style={{ fontSize: '1.08rem', fontWeight: 700, marginBottom: 4, color: '#FDC30F', lineHeight: 1.2 }}>{currentImages[current].title}</h3>
                      <p style={{ fontSize: '0.97rem', marginBottom: 2, color: '#FDC30F', lineHeight: 1.3 }}>{currentImages[current].description}</p>
                      <p style={{ fontSize: '0.85rem', marginTop: 4, opacity: 0.7 }}>Klikněte pro zvětšení</p>
                    </div>

                    <button
                      onClick={(e) => { e.stopPropagation(); next(); }}
                      aria-label="Další"
                      className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-[#FDC30F] text-[#1F2E46] rounded-full p-2 sm:p-3 shadow transition-all z-10 border-none cursor-pointer"
                      style={{ boxShadow: '0 2px 8px #1F2E46', border: 'none' }}
                    >
                      <svg width="22" height="22" className="sm:w-7 sm:h-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" /></svg>
                    </button>
                  </div>

                  <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                    {currentImages.map((img, i) => (
                      <button key={i} onClick={() => setCurrent(i)} style={{ width: 16, height: 16, borderRadius: '50%', border: '2px solid', background: i === current ? '#FDC30F' : '#F8FAFC', borderColor: i === current ? '#FDC30F' : '#1F2E46', transition: 'all 0.2s', cursor: 'pointer' }}></button>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}

          {/* Modal pro zvětšené obrázky */}
          {isModalOpen && currentImages.length > 0 && (
            <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4" onClick={closeModal}>
              <div className="relative max-w-6xl max-h-full" onClick={(e) => e.stopPropagation()}>
                <button onClick={closeModal} className="absolute top-4 right-4 text-white hover:text-[#FDC30F] transition-colors z-10">
                  <svg width="32" height="32" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M18 6L6 18M6 6l12 12" />
                  </svg>
                </button>

                <button onClick={modalPrev} className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-[#FDC30F]/80 hover:bg-[#FDC30F] text-[#1F2E46] rounded-full p-2 sm:p-3 shadow transition-all z-10">
                  <svg width="22" height="22" className="sm:w-7 sm:h-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>
                </button>

                <div style={{width: '100%', height: '100%', minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <Image
                    src={currentImages[modalCurrent].src}
                    alt={currentImages[modalCurrent].title}
                    width={1200}
                    height={800}
                    style={{objectFit: 'contain', maxHeight: '85vh', width: 'auto', margin: '0 auto'}}
                    className="w-full h-full object-contain"
                    placeholder="blur"
                    blurDataURL="/galerie/placeholder.webp"
                  />
                </div>

                <button onClick={modalNext} className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-[#FDC30F]/80 hover:bg-[#FDC30F] text-[#1F2E46] rounded-full p-2 sm:p-3 shadow transition-all z-10">
                  <svg width="22" height="22" className="sm:w-7 sm:h-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" /></svg>
                </button>

                <div
                  className="absolute bottom-4 left-1/2 -translate-x-1/2 text-center rounded-lg max-w-lg"
                  style={{
                    background: 'rgba(31,46,70,0.65)',
                    color: '#FDC30F',
                    padding: '1.1rem 1.2rem 0.7rem 1.2rem',
                    fontSize: '1rem',
                    boxShadow: '0 2px 12px 0 rgba(31,46,70,0.10)',
                    width: '90vw',
                    maxWidth: 420,
                  }}
                >
                  <h3 style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: 6, color: '#FDC30F', lineHeight: 1.2 }}>{currentImages[modalCurrent].title}</h3>
                  <p style={{ fontSize: '0.98rem', marginBottom: 4, color: '#FDC30F', lineHeight: 1.3 }}>{currentImages[modalCurrent].description}</p>
                  <p style={{ fontSize: '0.85rem', marginTop: 6, opacity: 0.7 }}>{modalCurrent + 1} / {currentImages.length}</p>
                </div>
              </div>
            </div>
          )}

        </div> {/* end of .max-w-6xl mx-auto px-6 */}
        {/* Info text moved closer to the footer for consistent spacing */}
        <div
          style={{
            textAlign: 'center',
            marginTop: '3.5rem',
            marginBottom: '2.5rem',
            color: '#1F2E46',
          }}
        >
          <p style={{ fontSize: '1.1rem' }}>
            Chcete vidět více realizovaných prací?{' '}
            <a href="mailto:info@elektroinstalacetrunec.cz" style={{ color: '#FDC30F', fontWeight: 700, textDecoration: 'underline' }}>info@elektroinstalacetrunec.cz</a> pro podrobnosti.
          </p>
        </div>
      </main>

      {/* Footer ve žluté a tmavě modré */}
      <footer style={{ background: '#1F2E46', borderTop: '2px solid #FDC30F' }}>
        <style>{`
    .footer-text { color: rgba(255, 255, 255, 0.75); font-size: 0.95rem; }
    .footer-link { color: rgba(255, 255, 255, 0.75); text-decoration: none; transition: color 0.2s ease; }
    .footer-link:hover { color: #fff; text-decoration: underline; text-underline-offset: 4px; }
  `}</style>

        {/* Sníženo vnitřní odsazení (padding) pro zmenšení celkové výšky */}
        <div className="max-w-6xl mx-auto px-6" style={{ padding: '1rem 1.5rem' }}>

          {/* Kontaktní údaje zarovnané přesně na střed, jednotný font a barvy */}
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 footer-text">
            <span>IČO: 23403195</span>

            {/* Oddělovací tečka (viditelná jen na větších obrazovkách) */}
            <span className="hidden md:inline-block w-1.5 h-1.5 rounded-full bg-white opacity-20"></span>

            <a href="tel:+420704280499" className="footer-link">+420 704 280 499</a>

            {/* Oddělovací tečka */}
            <span className="hidden md:inline-block w-1.5 h-1.5 rounded-full bg-white opacity-20"></span>

            <a href="mailto:info@elektroinstalacetrunec.cz" className="footer-link">info@elektroinstalacetrunec.cz</a>
          </div>

          {/* Spodní lišta - sníženy mezery marginTop a paddingTop nad a pod čarou */}
          <div className="flex justify-center" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.12)' }}>
            <p style={{ margin: 0, color: 'rgba(255,255,255,0.55)', fontSize: '0.85rem', textAlign: 'center' }}>
              © 2026 <span style={{ color: '#fff', fontWeight: 700 }}>Elektroinstalace Trunec</span>. Powered by{' '}
              <a href="https://www.instagram.com/zdenek_pesa" target="_blank" rel="noopener noreferrer" className="footer-link" style={{ color: '#fff', fontWeight: 600 }}>Zdeněk Pešek</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
